import { render, staticRenderFns } from "./InputRadioMutiple.vue?vue&type=template&id=2927dcd4&scoped=true"
import script from "./InputRadioMutiple.vue?vue&type=script&lang=js"
export * from "./InputRadioMutiple.vue?vue&type=script&lang=js"
import style0 from "./InputRadioMutiple.vue?vue&type=style&index=0&id=2927dcd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927dcd4",
  null
  
)

export default component.exports